<template>

<core-dropdown class="input" trigger="manual" v-on:forceClose="is.expanded = false" :expanded="is.expanded" v-click-outside="onOutsideClick">

	<core-button v-on:click.native="onToggleClick" :icon="forceIcon" theme="filter" :iconLeft="$isMobile" :caret="true" :class="{'has-prefix': prefix}">{{ prefix }} <b>{{ text }}</b></core-button>
	
	<portal to="mobileactions" v-if="$isMobile && $route.meta.hasActions">

		<core-button 
			v-on:click.native="onToggleClick" 
			theme="filter" 
			:icon="forceIcon" 
			text="Mode" 
			:icon-left="true" 
		/>
	
	</portal>

	<core-dropdown-list :title="title" :expanded="is.expanded" theme="filter" :caret="true" type="button" v-propagation v-on:close="is.expanded = false">

		<core-dropdown-item v-for="layout in layouts" :icon="layout.icon" :key="layout.value" type="action" v-bind:class="{'is-active': value === layout.value}" v-on:click.native="onOptionClick(layout.value)">{{ layout.name }}</core-dropdown-item>

		<slot></slot>

	</core-dropdown-list>

</core-dropdown>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: [
		'filter', 'page', 'on', 'off', 'prefix', 'title', 'forceIcon'
	],
	
	data: function() {

		return {
			is: {
				expanded: false
			}
		}

	},

	computed: {

		text: function() {
		
			return (this.value === 1) ? this.on : this.off

		},

		layouts: function() {

			return [
				{ name: this.off, value: 0 },
				{ name: this.on, value: 1 }
			]

		},

		icon: function() {

			return this.$_.findWhere(this.layouts, {
				value: this.value
			}).icon

		},

		value: function() {

			return this.$store.getters['filter/' + this.filter]

		}

	},

	methods: {

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOutsideClick: function() {

			this.is.expanded = false

		},

		onOptionClick: function(value) {

			this.$store.commit('filter/' + this.filter, value)

			this.is.expanded = false

		}

	}

}

</script>

<style scoped>

</style>
